import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  avatar: {
    // cursor: 'pointer',
  },

  menuContainer: {
    width: '150px',
    maxWidth: '150px',
    minWidth: 'unset',

    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  },
  menuItem: {},
}));
